import { mountStandaloneApp } from '@yuksalish/ui'
import ShiftDashboardPage from './pages/ShiftDashboardPage.vue'
import ActiveOrdersPage from './pages/ActiveOrdersPage.vue'
import ProductionOrderDetailPage from './pages/ProductionOrderDetailPage.vue'
import AssignmentsPage from './pages/AssignmentsPage.vue'
import HourlyOutputPage from './pages/HourlyOutputPage.vue'
import DowntimePage from './pages/DowntimePage.vue'
import HandoverPage from './pages/HandoverPage.vue'
import HelpPage from './pages/HelpPage.vue'
import { shopfloorMessages } from './i18n'
import { setupTabletMenu } from './mobileMenu'
import './tablet.css'

mountStandaloneApp({
  code: 'shopfloor',
  title: 'Ishlab chiqarish maydoni',
  description: 'Smena boshqaruvi, ishchi va mashina taqsimoti, ishlab chiqarish, to‘xtalishlar va smena topshirish.',
  messages: shopfloorMessages,
  accent: '#b3472d',
  // The tablet skin (tablet.css + mobileMenu.ts) owns the small-screen shell.
  mobileTopbar: false,
  navigation: [
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.shiftDashboard,
        ru: shopfloorMessages.ru.shopfloor.nav.shiftDashboard,
        uz: shopfloorMessages.uz.shopfloor.nav.shiftDashboard,
      },
      to: '/',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.activeOrders,
        ru: shopfloorMessages.ru.shopfloor.nav.activeOrders,
        uz: shopfloorMessages.uz.shopfloor.nav.activeOrders,
      },
      to: '/orders',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.assignments,
        ru: shopfloorMessages.ru.shopfloor.nav.assignments,
        uz: shopfloorMessages.uz.shopfloor.nav.assignments,
      },
      to: '/assignments',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.hourlyOutput,
        ru: shopfloorMessages.ru.shopfloor.nav.hourlyOutput,
        uz: shopfloorMessages.uz.shopfloor.nav.hourlyOutput,
      },
      to: '/output',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.downtime,
        ru: shopfloorMessages.ru.shopfloor.nav.downtime,
        uz: shopfloorMessages.uz.shopfloor.nav.downtime,
      },
      to: '/downtime',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.handover,
        ru: shopfloorMessages.ru.shopfloor.nav.handover,
        uz: shopfloorMessages.uz.shopfloor.nav.handover,
      },
      to: '/handover',
      permission: 'production_orders.view',
    },
    {
      label: {
        en: shopfloorMessages.en.shopfloor.nav.help,
        ru: shopfloorMessages.ru.shopfloor.nav.help,
        uz: shopfloorMessages.uz.shopfloor.nav.help,
      },
      to: '/help',
      permission: 'production_orders.view',
    },
  ],
  requiredPermissions: ['production_orders.view'],
  routes: [
    { path: '', component: ShiftDashboardPage, meta: { permission: 'production_orders.view' } },
    { path: 'orders', component: ActiveOrdersPage, meta: { permission: 'production_orders.view' } },
    { path: 'orders/:id', component: ProductionOrderDetailPage, meta: { permission: 'production_orders.view' } },
    { path: 'assignments', component: AssignmentsPage, meta: { permission: 'production_orders.view' } },
    { path: 'output', component: HourlyOutputPage, meta: { permission: 'production_orders.view' } },
    { path: 'downtime', component: DowntimePage, meta: { permission: 'production_orders.view' } },
    { path: 'handover', component: HandoverPage, meta: { permission: 'production_orders.view' } },
    { path: 'help', component: HelpPage, meta: { permission: 'production_orders.view' } },
    { path: 'help/:slug', component: HelpPage, meta: { permission: 'production_orders.view' } },
  ],
})

setupTabletMenu()
